import {
  ContaPassivelDeAdicaoAoRateio,
  ListarContasPassiveisDeAdicaoRequest
} from "../typings";
import  http  from 'infra/http';

import { useInfiniteQuery } from "react-query";

function useContasPassiveisDeAdicaoAoRateio(id: string, params: ListarContasPassiveisDeAdicaoRequest) {
  const parseValuesParams = Object.values(params)
    .map((value) => `${value}`)
    .join("-");

  return useInfiniteQuery(
    `/v1/rateio/${id}/contas-passiveis-adicao-${parseValuesParams}`,
    async ({ pageParam }) => {
      const { data } = await http.get<{items: ContaPassivelDeAdicaoAoRateio[]}>(
        `/v1/rateio/${id}/contas-passiveis-adicao`,
        {
          params: {
            ...params,
            page: pageParam,
          },
        }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage, allPages) =>
        lastPage.items.length <  0
          ? undefined
          : allPages.length + 1
    }
  );
}

export default useContasPassiveisDeAdicaoAoRateio;
